import { IComponentOptions, IController } from "angular";

class NoResultsErrorComponentCtrl implements IController {
  errorType: string;
}

export const NoResultsErrorComponent: IComponentOptions = {
  bindings: {
    errorType: "<",
  },
  template: require("./no-results-error.html"),
  controller: NoResultsErrorComponentCtrl,
};
